import { render, staticRenderFns } from "./flzgcyz.vue?vue&type=template&id=6b2b51a0&scoped=true"
import script from "./flzgcyz.vue?vue&type=script&lang=js"
export * from "./flzgcyz.vue?vue&type=script&lang=js"
import style0 from "./flzgcyz.vue?vue&type=style&index=0&id=6b2b51a0&prod&scoped=true&lang=less"
import style1 from "./flzgcyz.vue?vue&type=style&index=1&id=6b2b51a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b51a0",
  null
  
)

export default component.exports